import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Searchbar from "../../../Components/Searchbar/Searchbar";
import CustomButton from "../../../Components/Button/CustomButton";
import ProductTable from "../../../Components/Table/ProductTable";
import { Link } from "react-router-dom";
import { GetProduct } from "../../../APIs/Function/Product/GetProduct";
import { SearchDebouncing } from "../../../APIs/Search/SearchDebouncing";
import Loader from "../../../Components/Loader/Loader";

const Product = () => {
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  const [searchData, setSearchData] = useState([]);

  const handleProduct = async () => {
    try {
      setLoading(true);
      let res = await GetProduct();
      setProductData(res.r);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    if (searchValue.length === 0) {
      setSearchData([]);
      setSearched(false);
      return;
    }

    try {
      await SearchDebouncing(2, searchValue, setSearchData);
      setSearched(true);
    } catch (error) {
      console.log(error);
    }
  };
  const handleClearSearch = () => {
    console.log("Before Clear Search:", productData);
    // Reset the search state and reload the original data
    setSearched(false);
    handleProduct();
    console.log("After Clear Search:", productData);
  };

  useEffect(() => {
    handleProduct();
  }, []);

  return (
    <>
      {loading ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box sx={{ p: 2, boxSizing: "border-box" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "30px" }}>
            <Box sx={{ width: "80%" }}>
              <Searchbar
                onChange={handleSearch}
                onClear={handleClearSearch}
                placeholder={"Search Product"}
              />
            </Box>
            <Box sx={{ width: "10%" }}>
              <Link to={"/addproduct"}>
                <CustomButton
                  sx={{
                    width: "150px",
                    height: "60px",
                    bgcolor: "#31AEF4",
                    transition: "transform 0.3s",
                    "&:hover": {
                      background: "#31AEF4",
                      transform: "scale(1.1)",
                    },
                  }}
                >
                  Add Product +
                </CustomButton>
              </Link>
            </Box>
          </Box>
          <Box>
            {searched && searchData.length > 0 ? (
              <ProductTable
                setProductData={setProductData}
                productData={searchData}
                loading={loading}
              />
            ) : !searched ? (
              <ProductTable
                setProductData={setProductData}
                productData={productData}
                loading={loading}
              />
            ) : (
             ""
            )}
       
          </Box>
        </Box>
      )}
    </>
  );
};

export default Product;
